import RenderWalletModal from './RenderWallet';
export { network } from './connectors';

export default RenderWalletModal;
